@if (form) {
    <form [formGroup]="form" class="w-100 h-fit-content" fxLayout="column" fxLayoutAlign="start start">
        <mat-accordion class="w-100">
            @for (entryForm of form.controls?.entries?.controls; track trackByEntryIndex(index, entryForm); let
                index = $index; let last = $last) {
                <af-msisdn-fraud-expansion-panel
                    [form]="entryForm"
                    [expanded]="last"
                    [hasDeleteButton]="showDeleteButton"
                    [hasAddEntryButton]="last && canAddMoreEntries"
                    [isAddEntryButtonDisabled]="form.invalid"
                    [index]="index"
                    (deleteEntryListener)="deleteEntry($event)"
                    (addNewEntryListener)="addEntry()"/>
            }
        </mat-accordion>
    </form>
}
